import { render } from "./page-archive.vue?vue&type=template&id=56ff38ed&scoped=true"
import script from "./page-archive.vue?vue&type=script&lang=js"
export * from "./page-archive.vue?vue&type=script&lang=js"

import "./page-archive.vue?vue&type=style&index=0&id=56ff38ed&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ff38ed"],['__file',"src/components/notepad/pages/page-archive.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56ff38ed"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56ff38ed', __exports__)) {
    api.reload('56ff38ed', __exports__)
  }
  
  module.hot.accept("./page-archive.vue?vue&type=template&id=56ff38ed&scoped=true", () => {
    api.rerender('56ff38ed', render)
  })

}


export default __exports__